import React from 'react'
import { Button, Tooltip, Modal } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import classNames from 'classnames'
import customLanguageTexts from '../../../../language'
import { checkIfCustomOldPlan, checkIfTrialOrExpired } from '../../../../helpers'
import './index.css'

const mapStateToProps = ({ apps }) => ({ apps })
@connect(mapStateToProps)
@withRouter
class ButtonUpgrade extends React.Component {
  state = {
    changeCustomPlanIntentSent: false,
  }

  handleUpgradePlan = () => {
    const { dispatch, featureSlug } = this.props

    dispatch({
      type: 'apps/UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT',
      payload: { featureSlug, setLoader: true },
    })
  }

  handleShowCustomUnsubscribeWarning = () => {
    const { changeCustomPlanIntentSent } = this.state
    if (!changeCustomPlanIntentSent) {
      const { dispatch } = this.props

      dispatch({
        type: 'apps/CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT',
        onComplete: this.limitDuplicateIntentsForChangeCustomPlan,
      })
    }

    let contentMsg = customLanguageTexts.CUSTOM_PLAN_UNSUBSCRIBE_MODAL_MSG
    let titleMsg = customLanguageTexts.CUSTOM_PLAN_UNSUBSCRIBE_MODAL_TITLE
    const { appVersion, appPlan } = this.props
    if (appVersion === '1' && checkIfTrialOrExpired(appPlan)) {
      contentMsg = customLanguageTexts.CUSTOM_PLAN_V1_APPS_FREE_UNSUBSCRIBE_MODAL_MSG
      titleMsg = customLanguageTexts.CUSTOM_PLAN_V1_APPS_FREE_UNSUBSCRIBE_MODAL_TITLE
    }
    Modal.confirm({
      title: titleMsg,
      content: contentMsg,
      onOk() {},
      onCancel() {},
      closable: true,
      cancelType: 'primary',
      okText: 'Contact us',
      okButtonProps: {
        href: 'https://www.cometchat.com/contact-sales/',
        target: '_blank',
        htmlType: 'button',
      },
      cancelButtonProps: {
        className: 'mr-4',
        htmlType: 'button',
      },
      cancelText: 'Close',
    })
  }

  render() {
    const { appPlan, tootlipPlacement, apps } = this.props

    let changePlanButton = (
      <Tooltip
        placement={tootlipPlacement === 'right' ? 'right' : 'bottom'}
        title={customLanguageTexts.CHAT_WIDGET_UPGRADE_PLAN_ON_RESTRICTED_FEATURE}
      >
        <div className={classNames('button-holder-upgrade', '')}>
          <Link to={`/app/${apps.active.id}/plans-billing`}>
            <div
              className="warningIcon"
              onClick={() => this.handleUpgradePlan()}
              aria-hidden="true"
            />
          </Link>
        </div>
      </Tooltip>
    )

    if (checkIfCustomOldPlan(appPlan)) {
      changePlanButton = (
        <Tooltip
          placement={tootlipPlacement === 'right' ? 'right' : 'bottom'}
          title={customLanguageTexts.CHAT_WIDGET_UPGRADE_PLAN_ON_RESTRICTED_FEATURE}
        >
          <div className="button-holder-upgrade">
            <Button
              type="default"
              shape="circle"
              size="small"
              onClick={() => this.handleShowCustomUnsubscribeWarning()}
            >
              {' '}
              <i className="fe fe-chevrons-up" />{' '}
            </Button>
          </div>
        </Tooltip>
      )
    }
    return changePlanButton
  }
}

export default ButtonUpgrade
